import {request} from '@/utils/request'
import { getToken } from '@/utils/auth'

// 登录方法
export function login(username, password) {
  return request({
    url: '/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: { username, password }
  })
}

// 微信登录方法
export function wixinLogin(params) {
  return request({
    url: '/auth/platform/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: params
  })
}

// 注册方法
export function register(phone, code) {
  return request({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: {phone, code}
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    headers: {
      Authorization: "Bearer " + getToken()
    },
    method: 'delete'
  })
}

// // 获取验证码
// export function getCodeImg() {
//   return request({
//     url: '/code',
//     headers: {
//       isToken: false
//     },
//     method: 'get',
//     timeout: 20000
//   })
// }